/**
 * bustCachesAndReload — the app's escape hatch from a broken bundle.
 *
 * A plain reload is not enough when a stale service worker is the cause: it
 * keeps serving its old precached index, which points at hashed chunks that
 * 404 after a deploy, so the reload loops on the same broken build. Dropping
 * the worker AND its caches forces the next load to come from the network.
 *
 * Lives here rather than in main.tsx so the route-level loading screen can
 * offer the same recovery — a user stuck on a spinner needs exactly this, and
 * duplicating it would let the two copies drift.
 */
export async function bustCachesAndReload(): Promise<void> {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((r) => r.unregister()))
    }
    if ("caches" in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map((k) => caches.delete(k)))
    }
  } catch {
    /* best-effort — reload regardless */
  }
  window.location.reload()
}

export default bustCachesAndReload
